<app-page-heading [key]="'load-handovers.map.page-title'" [subheadingIcon]="'fa fa-truck'" [disableMarginBottom]="true">
</app-page-heading>

<div class="full-height">
    <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [disableDefaultUI]="true" (mapReady)="mapReady($event)"
             [disableDoubleClickZoom]="true" [draggable]="false" [keyboardShortcuts]="false" [usePanning]="true">
        <agm-zoom-control></agm-zoom-control>

        <agm-marker-cluster [imagePath]="'https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m'"
                            [averageCenter]="true" [maxZoom]="15">
            <ng-container *ngFor="let group of loadHandoverGroups">
            <ng-container *ngFor="let loadHandover of group.loadHandovers">
                <agm-marker (markerClick)="getGroupDetails(group)" [zIndex]="5"
                            [label]="{color: '#0078bd', fontSize: '18px', fontWeight: 'bold', text: showOnlyOldHandover ? '' + group.nbOldLoadHandovers : '' + group.nbLoadHandovers}"
                            [visible]="showOnlyOldHandover ? loadHandover === group.firstOldLoadHandover : loadHandover === group.firstLoadHandover"
                            [latitude]="group.latitude" [longitude]="group.longitude" [iconUrl]="getMapMarker(group)"
                            *ngIf="loadHandover.isOld || !showOnlyOldHandover">
                    <agm-snazzy-info-window [closeWhenOthersOpen]="true" [showCloseButton]="false" [maxWidth]="400" [maxHeight]="500">
                        <ng-template>
                            <div class="load-handover-details" *ngFor="let loadHandover of group.loadHandovers">
                                <div class="load-handover-date" [i18n]="[{target: 'innerHTML', key: 'load-handovers.map.handover-list.since', params: {date: loadHandover.releasedAt | fullDate }}]"></div>
                                <div class="load-handover-load-number"><span [i18n]="[{target: 'innerHTML', key: 'load-handovers.map.handover-list.load'}]"></span> # :
                                    <a class="cmaweb-link" [href]="link.goToLoadManagementForLoad(loadHandover.loadNumber)" target="_blank">{{loadHandover.loadNumber}}</a>
                                </div>
                                <div class="load-handover-delivery-numbers"><span [i18n]="[{target: 'innerHTML', key: 'load-handovers.map.handover-list.deliveries'}]"></span> # :
                                    <a class="cmaweb-link" [href]="link.goToLoadManagementForDelivery(loadHandover.shipmentNumbers.join(','))" target="_blank">{{loadHandover.shipmentNumbers.join(', ')}}</a>
                                </div>
                                <div class="load-handover-sales-orders" *ngIf="loadHandover.salesOrderNumber.length > 0">
                                    <span [i18n]="'load-handovers.map.handover-list.sales-orders'"></span> # : {{loadHandover.salesOrderNumber.join(', ')}}
                                </div>
                                <div *ngIf="canViewOnLoadTracking && loadHandover.tripId" class="load-handover-link"><a (click)="redirectToLoadTracking(loadHandover, $event)" [i18n]="[{target: 'innerHTML', key: 'load-handovers.map.handover-list.view-trip'}]"></a></div>
                            </div>
                            <div class="load-handover-location">
                                <i class="fa fa-map-marker-alt"></i> <span> {{ selectedHandoverAddress }}</span>
                            </div>
                        </ng-template>
                    </agm-snazzy-info-window>
                </agm-marker>
            </ng-container>
            </ng-container>
        </agm-marker-cluster>

    </agm-map>

    <app-map-overlay>
        <app-map-overlay-header class="handover-filter-action">
            <h3 class="handover-title" [i18n]="[{target: 'innerHTML', key: 'load-handovers.map.handover-list.title'}]"></h3>

            <select *ngIf="carrierSelectionAvailable" [(ngModel)]="selectedCarrier" class="select-carriers form-control" (change)="carrierChanged()">
                <option [ngValue]="null" [i18n]="[{target: 'innerHTML', key: 'load-handovers.map.carriers.default'}]"></option>
                <option *ngFor="let c of carriers" [ngValue]="c">{{c.name}}</option>
            </select>

            <button class="btn btn-white"  (click)="clickFilterHandovers()" [ngClass]="{ 'active': filterHandovers }">
                <i class="fa fa-filter"></i>
            </button>

            <button class="btn btn-white btn-img" (click)="clickEmergencyFilter()" [ngClass]="{ 'active': showOnlyOldHandover }"
                    [i18n]="[{target: 'attribute:title', key: 'load-handovers.filters.older-loads.tooltip'}]">
                <img class="icon-img" [src]="oldReleasedDropIconUrl">
            </button>
        </app-map-overlay-header>
        <app-map-overlay-content>
            <div class="ibox-content handover-filter" *ngIf="filterHandovers">
                <input class="handover-filter-input" [(ngModel)]="filterHandoversInput"
                       [i18n]="[{target: 'attribute:placeholder', key: 'load-handovers.filters.placeholder'}]"
                       appAutofocus (keyup)="applyFilters()">
                <i class="fa fa-close" (click)="resetFilter()"></i>
            </div>
            <div class="handover-list">
                <div *ngFor="let loadHandover of filteredLoadHandovers" (click)="zoomOnHandover(loadHandover)">
                    <div class="ibox-content handover-row-container" [ngClass]="{ 'selected': loadHandover === selectedHandover} " (click)="selectHandover(loadHandover)">
                        <div class="handover-row-icon">
                            <img class="img-marker" [src]="getListMarker(loadHandover)">
                        </div>
                        <h3 class="handover-row-delivery">
                            <span class="delivery-number" [popover]="salesOrderPopTemplate" placement="right" container="body" triggers="mouseenter:mouseleave">
                                <span [i18n]="'load-handovers.map.handover-list.delivery'"></span> # : {{loadHandover.shipmentNumbers.join(', ')}}
                            </span>
                        </h3>
                        <ng-template #salesOrderPopTemplate>
                            <chp-delivery-and-sales-order-numbers
                                [deliveryNumbers]="loadHandover.shipmentNumbers"
                                [salesOrderNumbers]="loadHandover.salesOrderNumber">
                            </chp-delivery-and-sales-order-numbers>
                        </ng-template>
                        <h5 class="handover-row-time"> {{loadHandover.releasedAt | dateDiffFromNow | async}} </h5>
                    </div>
                </div>
            </div>
            <div class="ibox-content handover-row-container" *ngIf="filteredLoadHandovers.length === 0">
                <i><em [i18n]="[{target: 'innerHTML', key: 'load-handovers.load-details.no-load'}]"></em></i>
            </div>
        </app-map-overlay-content>
    </app-map-overlay>
</div>
